export const Plans = {
  ANNUAL: 'fffvipa',
  SEASONAL: 'fffvip',
  TRIAL: 'ffftrial',
};

export const PlansLiteral = {
  ANNUAL: 'select',
  SEASONAL: 'seasonal',
  TRIAL: 'trial',
};

export const DESKTOP = 'desktop';
export const TABLET = 'tablet';
export const MOBILE = 'mobile';

export const couponScreenKey = {
  UPGRADE: 'upgrade',
  REACTIVATE_EXPIRED_SUBSCRIPTION: 'reactivate-expired-subscription',
};

export const taxTextsByCountry = (countryCode: string) => {
  if (countryCode === 'CA') {
    return {
      description: 'Taxes (Import/Border)',
      disclaimer:
        'Taxes (Import/Border) reflects sales taxes collected by ' +
        'CBSA at the time of import of your order and paid by FabFitFun on your behalf.',
    };
  }
  if (countryCode === 'GB') {
    return {
      description: 'VAT (Import) to be paid on your behalf',
      disclaimer:
        'The amount shown is the cost we incur in paying VAT on your behalf upon importation.',
    };
  }
  return {
    description: 'Tax',
    disclaimer: '',
  };
};

export const PriceLockStatus = {
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PAYMENT_PROCESSED: 'PAYMENT_PROCESSED',
  PAYMENT_FAILURE: 'PAYMENT_FAILURE',
  NOT_REQUESTED: 'NOT_REQUESTED',
};

export const PriceLockStatusMessage = {
  PAYMENT_PENDING:
    'Request sent! Please allow 1 business day for our team to process your request.',
  PAYMENT_PROCESSED:
    'Payment processed! Your rate has been locked in successfully for an additional 4 boxes.',
  PAYMENT_FAILURE:
    'Your payment failed! Please update your payment method and then contact Customer Care Team directly to lock in your price.',
  NOT_REQUESTED: '',
};

export const SALE_TYPE = {
  additionalChoices: 'Additional Choice',
  addons: 'Add-Ons',
  box: 'Box',
  edit: 'Edit',
  boost: 'Boost',
  replenishment: 'reFills',
  shop: 'The Shop',
  subscription: 'Subscriptions',
};

export const SEASON = {
  '01': 'Spring',
  '02': 'Summer',
  '03': 'Fall',
  '04': 'Winter',
};

export const NUMBER_OF_SEASONS_PER_YEAR = 4;

export const WAREHOUSE = {
  envista: 'envista',
  enspire: 'enspire',
};

export const UPGRADE_CONFIRMATION_TITLE_DEFAULT = 'Upgrade Now';
export const CANCEL_SUBSCRIPTION_LABEL = 'Cancel Subscription';
export const REACTIVATE_MEMBERSHIP_LABEL = 'Reactivate Membership';
export const MY_ACCOUNT_EXPERIENCE = 'My Account';
export const TRACK_NAME_LABEL = 'Cancel Flow Accessed';
export const CANCEL_BOX_SUBSCRIPTION_LABEL = 'Cancel Beauty Edit Box Subscription';

export const BOX_STATUS = {
  FULFILLABLE: 'FULFILLABLE',
  REFUND: 'REFUND',
  CSR: 'CSR',
  CREDIT: 'CREDIT',
  EXPIRED: 'EXPIRED',
  SUBMITTED: 'SUBMITTED',
  INCOMPLETE: 'INCOMPLETE',
  UNKNOWN: 'UNKNOWN',
  SKIPPED: 'SKIPPED',
  SKIPPED_INTRO: 'SKIPPED_INTRO',
};

export const SUBSCRIPTION_STATUS = {
  EXPIRED: 'EXPIRED' as const,
  ACTIVE: 'ACTIVE' as const,
  CANCELED: 'CANCELED' as const,
};

export const PAGE_LOAD_EVENT_TITLE = 'Page Load';
export const COUPON_CODE_QUERY_PARAM = 'coupon_code';
export const EXPIRED_SUBSCRIPTION_STATE = 'expired';
export const LOGGED_OUT_STATE = 'logged out';
export const SECTION_ID = 'plans';

export const REACTIVATION_COMPLETED_EVENT = 'Reactivation Completed';
export const REACTIVATION_COMPLETED_EVENT_TYPE = 'Canceled Member';
export const REACTIVATION_EXPERIENCE = 'cancel flow';
